import { render, staticRenderFns } from "./Destino.vue?vue&type=template&id=5fbf73f9&"
import script from "./Destino.vue?vue&type=script&lang=js&"
export * from "./Destino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports